import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.css'],
})
export class PageHeaderComponent implements OnInit {
  @Input() public title: any

  constructor() {}

  ngOnInit() {}
}
